module.exports = "/fonts/tech.svg?6d278f865b5a10c25a7656a488e2de1b";


//////////////////
// WEBPACK FOOTER
// ./public/img/icons/tech.svg
// module id = G4UE
// module chunks = 3